import { render, staticRenderFns } from "./ReporteSaldos.vue?vue&type=template&id=9ef7004c&scoped=true"
import script from "./ReporteSaldos.vue?vue&type=script&lang=js"
export * from "./ReporteSaldos.vue?vue&type=script&lang=js"
import style0 from "./ReporteSaldos.vue?vue&type=style&index=0&id=9ef7004c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef7004c",
  null
  
)

export default component.exports